module.exports = __webpack_public_path__ + "img/5.76ca4918.png";